
// import { Link } from "react-router-dom";

// function Footer() {
//   return (
//     <footer className="bg-black text-gray-300 py-12 border-t border-gray-800">
//       <div className="max-w-7xl mx-auto px-6">
//         {/* Grid Layout */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
//           {/* Left: Logo + About */}
//           <div>
//             <h2 className="text-orange-500 font-bold text-2xl mb-4">
//               MF Blinds & Carpet
//             </h2>
//             <p className="text-sm text-gray-400 leading-relaxed">
//               Premium blinds and plush carpets for every space. Professional
//               installation and deep cleaning for a fresh, elegant look.
//               Satisfaction guaranteed!
//             </p>

//             {/* Social Icons */}
//             <div className="flex flex-wrap gap-4 mt-6">
//               <a
//                 href="https://www.instagram.com/wahabnadeem24"
//                 aria-label="Instagram"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png"
//                   alt="Instagram"
//                   className="w-7 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>

//               <a
//                 href="https://www.facebook.com/share/3ZPrQMwiWq9XViwB/"
//                 aria-label="Facebook"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Facebook_colored_svg_copy-512.png"
//                   alt="Facebook"
//                   className="w-7 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>

//               <a
//                 href="https://wa.me/+447405264139"
//                 aria-label="WhatsApp"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
//                   alt="WhatsApp"
//                   className="w-7 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>

//               <a
//                 href="https://www.youtube.com/@TahirTechnology-ci6mz"
//                 aria-label="YouTube"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Youtube_colored_svg-512.png"
//                   alt="YouTube"
//                   className="w-7 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>

//               <a
//                 href="https://www.tiktok.com/@wahabnadeem24"
//                 aria-label="TikTok"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg"
//                   alt="TikTok"
//                   className=" bg-white w-20 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>


//               <a
//                 href="https://www.linkedin.com/in/wahabnadeem"
//                 aria-label="LinkedIn"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png"
//                   alt="LinkedIn"
//                   className="w-7 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>

//               <a
//                 href="https://twitter.com/wahabnadeem24"
//                 aria-label="Twitter"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Twitter_colored_svg-512.png"
//                   alt="Twitter"
//                   className="w-7 h-7 hover:scale-110 transition-transform"
//                 />
//               </a>
//             </div>
//           </div>

//           {/* Middle: Links */}
//           <div>
//             <h3 className="font-semibold text-lg mb-4 text-orange-500">
//               Quick Links
//             </h3>
//             <ul className="space-y-2 text-sm">
//               <li>
//                 <Link to="/blog" className="hover:text-orange-500">
//                   Blog
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/faq" className="hover:text-orange-500">
//                   FAQ
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/termsandconditions" className="hover:text-orange-500">
//                   Terms & Conditions
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/register" className="hover:text-orange-500">
//                   Register
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* Right: Contact */}
//           <div>
//             <h3 className="font-semibold text-lg mb-4 text-orange-500">
//               Contact Us
//             </h3>
//             <ul className="space-y-2 text-sm">
//               <li>📞 (+44) 7405264139</li>
//               <li>✉️ mfblindscarpet@gmail.com</li>
//               <li>📍 MF Blinds & Carpet, 65 Soverent Height SL3 8PZ</li>
//               <li>🕒 Mon - Fri, 8am - 5pm</li>
//             </ul>
//           </div>
//         </div>

//         {/* Bottom */}
//         <div className="mt-10 border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
//           <p>&copy; 2025 MF Blinds & Carpet. All rights reserved.</p>
//           <p className="mt-2 md:mt-0">
//             Powered by{" "}
//             <a
//               href="https://www.youtube.com/@TahirTechnology-ci6mz"
//               className="text-orange-500 hover:underline"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               Wahab & Tahir
//             </a>
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// import { Link } from "react-router-dom";

// function Footer() {
//   return (
//     <footer className="bg-green-900 text-gray-200 py-12 border-t border-green-800">
//       <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
//         {/* About */}
//         <div>
//           <h2 className="text-gold-400 font-bold text-2xl mb-4">
//             MF Blinds & Carpet
//           </h2>
//           <p className="text-gray-300 text-sm leading-relaxed">
//             Premium blinds, plush carpets & luxurious furniture. Expert installation & cleaning services.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 className="text-gold-400 font-semibold text-lg mb-4">Quick Links</h3>
//           <ul className="space-y-2 text-sm">
//             <li><Link to="/services" className="hover:text-gold-500 transition-colors">Services</Link></li>
//             <li><Link to="/about" className="hover:text-gold-500 transition-colors">About</Link></li>
//             <li><Link to="/contact" className="hover:text-gold-500 transition-colors">Contact</Link></li>
//             <li><Link to="/faq" className="hover:text-gold-500 transition-colors">FAQ</Link></li>
//           </ul>
//         </div>

//         {/* Contact */}
//         <div>
//           <h3 className="text-gold-400 font-semibold text-lg mb-4">Contact Us</h3>
//           <ul className="space-y-2 text-sm">
//             <li>📞 (+44) 7405264139</li>
//             <li>✉️ mfblindscarpet@gmail.com</li>
//             <li>📍 65 Soverent Height, SL3 8PZ</li>
//             <li>🕒 Mon - Fri, 8am - 5pm</li>
//           </ul>
//         </div>
//       </div>

//       <div className="mt-10 border-t border-green-800 pt-6 pl-4 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
//         <p>&copy; 2025 MF Blinds & Carpet. All rights reserved.</p>
//         {/* <p className="mt-2 md:mt-0">
//           Powered by{" "}
//           <a href="https://www.youtube.com/@TahirTechnology-ci6mz" target="_blank" rel="noopener noreferrer" className="text-gold-400 hover:underline">
//             Wahab & Tahir
//           </a>
//         </p> */}
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// green attempt

// import { Link } from "react-router-dom";

// function Footer() {
//   return (
//     <footer className="bg-green-900 text-gray-200 py-12 border-t border-green-800">
//       <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
//         {/* About */}
//         <div>
//           <h2 className="text-yellow-400 font-bold text-2xl mb-4">
//             MF Blinds & Carpet
//           </h2>
//           <p className="text-gray-300 text-sm leading-relaxed">
//             Premium blinds, plush carpets & luxurious furniture. Expert installation & cleaning services.
//           </p>
//             {/* Social Icons */}
//           <div className="flex flex-wrap gap-4 mt-6">
//             <a href="https://www.instagram.com/wahabnadeem24" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//               <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png" alt="Instagram" className="w-7 h-7 hover:scale-110 transition-transform" />
//             </a>
//             <a href="https://www.facebook.com/share/3ZPrQMwiWq9XViwB/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//               <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Facebook_colored_svg_copy-512.png" alt="Facebook" className="w-7 h-7 hover:scale-110 transition-transform" />
//             </a>
//             <a href="https://wa.me/+447405264139" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
//               <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-7 h-7 hover:scale-110 transition-transform" />
//             </a>
//             <a href="https://www.youtube.com/@TahirTechnology-ci6mz" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
//               <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Youtube_colored_svg-512.png" alt="YouTube" className="w-7 h-7 hover:scale-110 transition-transform" />
//             </a>
//             <a href="https://www.tiktok.com/@wahabnadeem24" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
//               <img src="https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg" alt="TikTok" className="w-7 h-7 hover:scale-110 transition-transform bg-white rounded" />
//             </a>
//             <a href="https://www.linkedin.com/in/wahabnadeem" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
//               <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png" alt="LinkedIn" className="w-7 h-7 hover:scale-110 transition-transform" />
//             </a>
//             <a href="https://twitter.com/wahabnadeem24" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//               <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Twitter_colored_svg-512.png" alt="Twitter" className="w-7 h-7 hover:scale-110 transition-transform" />
//             </a>
//           </div>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 className="text-yellow-400 font-semibold text-lg mb-4">Quick Links</h3>
//           <ul className="space-y-2 text-sm">
//             <li><Link to="/services" className="hover:text-yellow-500 transition-colors">Services</Link></li>
//             <li><Link to="/about" className="hover:text-yellow-500 transition-colors">About</Link></li>
//             <li><Link to="/contact" className="hover:text-yellow-500 transition-colors">Contact</Link></li>
//             <li><Link to="/faq" className="hover:text-yellow-500 transition-colors">FAQ</Link></li>
//           </ul>
//         </div>

//         {/* Contact & Social */}
//         <div>
//           <h3 className="text-yellow-400 font-semibold text-lg mb-4">Contact Us</h3>
//           <ul className="space-y-2 text-sm">
//             <li>📞 (+44) 7405264139</li>
//             <li>✉️ mfblindscarpet@gmail.com</li>
//             <li>📍 65 Soverent Height, SL3 8PZ</li>
//             <li>🕒 Mon - Fri, 8am - 5pm</li>
//           </ul>

        
//         </div>
//       </div>

//       {/* Footer Bottom */}
//       <div className="mt-10 border-t border-green-800 pt-6 pl-4 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
//         <p>&copy; 2025 MF Blinds & Carpet. All rights reserved.</p>
//         {/* Optional Powered by link */}
//         {/* <p className="mt-2 md:mt-0">
//           Powered by{" "}
//           <a href="https://www.youtube.com/@TahirTechnology-ci6mz" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">
//             Wahab & Tahir
//           </a>
//         </p> */}
//       </div>
//     </footer>
//   );
// }

// export default Footer;

import { Link } from "react-router-dom";

function Footer() {
  return (
<footer className="bg-lime-700 text-white py-12 border-t border-lime-500">
  <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between gap-10 px-6">

    {/* About */}
    <div className="flex-1 min-w-[200px]">
      <h2
        className="text-lime-100 font-bold text-2xl mb-4"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        MF Blinds & Carpets
      </h2>
      <p className="text-lime-50 text-sm leading-relaxed">
        Premium Blinds, Carpets & luxurious Furniture. Expert installation with fresh and elegant look.
      </p>

      {/* Social Icons */}
      <div className="flex gap-4 mt-6 flex-wrap md:flex-nowrap overflow-x-auto md:overflow-visible">
        {[
          { href: "https://www.instagram.com/wahabnadeem24", label: "Instagram", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png" },
          { href: "https://www.facebook.com/share/3ZPrQMwiWq9XViwB/", label: "Facebook", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Facebook_colored_svg_copy-512.png" },
          { href: "https://wa.me/+447405264139", label: "WhatsApp", src: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" },
          { href: "https://www.youtube.com/@TahirTechnology-ci6mz", label: "YouTube", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Youtube_colored_svg-512.png" },
          { href: "https://www.tiktok.com/@wahabnadeem24", label: "TikTok", src: "https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg", extraClass: "bg-white rounded" },
          { href: "https://www.linkedin.com/in/wahabnadeem", label: "LinkedIn", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png" },
          { href: "https://twitter.com/wahabnadeem24", label: "Twitter", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Twitter_colored_svg-512.png" },
        ].map((icon, i) => (
          <a key={i} href={icon.href} target="_blank" rel="noopener noreferrer" aria-label={icon.label}>
            <img src={icon.src} alt={icon.label} className={`w-7 h-7 hover:scale-110 transition-transform ${icon.extraClass || ""}`} />
          </a>
        ))}
      </div>
    </div>

    {/* Quick Links */}
    <div className="flex-1 min-w-[150px]">
      <h3
        className="text-lime-400 font-semibold text-lg mb-4"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Quick Links
      </h3>
      <ul className="space-y-2 text-sm">
        <li><Link to="/about" className="text-lime-50 hover:text-lime-200 transition-colors">About</Link></li>
        <li><Link to="/contact" className="text-lime-50 hover:text-lime-200 transition-colors">Contact</Link></li>
        <li><Link to="/faq" className="text-lime-50 hover:text-lime-200 transition-colors">FAQ</Link></li>
      </ul>
    </div>

    {/* Contact */}
    <div className="flex-1 min-w-[180px]">
      <h3
        className="text-lime-400 font-semibold text-lg mb-4"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Contact Us
      </h3>
    <ul className="space-y-2 text-sm text-lime-50">
    <li><a href="tel:+447405264139" target="_blank" rel="noopener noreferrer">📞 (+44) 7405264139</a></li>
    <li><a href="mailto:blindsmf@gmail.com" target="_blank" rel="noopener noreferrer">🧧 blindsmf@gmail.com</a></li>
    <li><a href="https://wa.me/447405264139" target="_blank" rel="noopener noreferrer">📍 Chat on WhatsApp (44) 7405264139</a></li>
</ul>
    </div>
  </div>

  {/* Footer Bottom */}
  <div className="mt-10 border-t border-lime-500 pt-6 px-4 flex flex-col md:flex-row justify-between items-center text-sm text-lime-300">
    <p className="text-center md:text-left" style={{ fontFamily: "'Playfair Display', serif" }}>
      &copy; 2025 MF Blinds & Carpets. All rights reserved.
    </p>
  </div>
</footer>


  );
}

export default Footer;
